// @ts-nocheck
import { Helmet } from 'react-helmet-async';
import VuiBreadcrumb from '../../../../../vodea/@vodea-ui/components/VuiBreadcrumb';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useState } from '@hookstate/core/dist';
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { InformationInputs, informationSchema, InformationBaseModel } from './validation';
import UserRepository from '../../../../../repositories/UserRepository';
import RoleRepository from '../../../../../repositories/RoleRepository';
import { AxiosError, AxiosResponse } from 'axios';
import { mapHookErrors, showToast } from '../../../../../vodea/utilities/helpers/global';
import useIsMounted from '../../../../../vodea/utilities/hooks/useIsMounted';
import VuiActionForm from '../../../../../vodea/@vodea-ui/components/Forms/VuiActionForm';
import { formatFormData, formatSetValueForm } from '../../../../../vodea/utilities/helpers/form';
import VuiUploadImage from '../../../../../vodea/@vodea-ui/components/Forms/VuiUploadImage';
import VuiSelect from '../../../../../vodea/@vodea-ui/components/Forms/VuiSelect';
import VuiDateRangePicker from '../../../../../vodea/@vodea-ui/components/Forms/VuiDateRangePicker';
import NumberFormat from 'react-number-format';
import moment from 'moment';

const SettingUserForm: React.FC<any> = () => {
  const { t } = useTranslation();
  const isMounted = useIsMounted();
  const navigate = useNavigate();
  const { id } = useParams();
  const informationData = useState({
    number: ''
  });

  const title = id ? t('Edit User') : t('Create User');

  useEffect(() => {
    if (id) {
      getData();
    }
  }, []); // eslint-disable-line

  const getData = () => {
    UserRepository.show(id, {
      with: ['roleUser.role', 'userPayroll']
    })
      .then((response: AxiosResponse) => {
        const data = response.data.data;

        const formattedData = formatSetValueForm(InformationBaseModel, data);

        if (isMounted.current) {
          informationData.set(data);
        }

        _.forEach(formattedData, (value, name) => {
          if (name === 'role_id') {
            informationSetValue(name, _.get(data, 'role_user.role'), {});
          } else {
            informationSetValue(name, value);
          }
        });
      })
      .catch((e: AxiosError) => {
        showToast(e.message, 'error');
      });
  };

  const informationLoading = useState(false);
  const {
    register: informationRegister,
    handleSubmit: informationHandleSubmit,
    errors: informationErrors,
    control: informationControl,
    setError: informationSetError,
    setValue: informationSetValue
  } = useForm<InformationInputs>({
    resolver: yupResolver(informationSchema),
    defaultValues: {
      dob: moment(),
      user_payroll: {
        monthly: 0,
        daily: 0
      }
    }
  });

  const onInformationSubmit = informationHandleSubmit(data => {
    informationLoading.set(true);
    const formData = formatFormData(data);

    if (id === undefined) {
      UserRepository.create(formData)
        .then((response: AxiosResponse) => {
          showToast(response.data.message, response.data.success ? 'success' : 'error');
          informationLoading.set(false);
          navigate('/setting/user');
        })
        .catch((e: AxiosError) => {
          if (isMounted.current && e?.response?.data?.errors) {
            const errors = mapHookErrors(e.response.data.errors);
            Object.keys(errors).forEach((key: any) => {
              informationSetError(key, errors[key]);
            });

            showToast(e.response.data.message, 'error');
          }

          informationLoading.set(false);
        });
    } else {
      UserRepository.update(id, formData)
        .then((response: AxiosResponse) => {
          showToast(response.data.message, 'success');
          informationLoading.set(false);
        })
        .catch((e: AxiosError) => {
          if (isMounted.current && e?.response?.data?.errors) {
            const errors = mapHookErrors(e.response.data.errors);
            Object.keys(errors).forEach((key: any) => {
              informationSetError(key, errors[key]);
            });
            showToast(e.response.data.message, 'error');
          }

          informationLoading.set(false);
        });
    }
  });

  const breadcrumbList = [
    {
      label: t('Setting'),
      link: '/setting'
    },
    {
      label: t('User'),
      link: '/setting/user'
    },
    {
      label: id ? id : t('Create'),
      link: '/setting/user/create'
    }
  ];

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <VuiBreadcrumb list={breadcrumbList} />

      <div className={'page-header-component'}>
        <h3 className={'title'}>{title}</h3>
      </div>
      <div id={'product-section'}>
        <form className={'form-wrapper'} onSubmit={onInformationSubmit}>
          <div className={'default-page-layout'}>
            <div className='multiple-paper-section'>
              <div className={'card-paper'}>
                <div className={'card-header'}>
                  <h6 className={'card-header-title'}>{t('Information')}</h6>
                </div>
                <div className={'card-content'}>
                  <div className='row'>
                    <div className={'col-md-6'}>
                      <div
                        className={clsx({
                          'form-group': true
                        })}
                      >
                        <label className={'form-label'}>User ID</label>
                        <input type='text' name='number' className='form-control' value={informationData.number.get()} disabled />
                      </div>
                    </div>
                    <div className={'col-md-6'}>
                      <div
                        className={clsx({
                          'form-group': true,
                          error: informationErrors.name
                        })}
                      >
                        <label className={'form-label'}>Name</label>
                        <input type='text' name='name' className='form-control' ref={informationRegister} />
                        <label className={'label-help'}>{informationErrors.name?.message}</label>
                      </div>
                    </div>
                    <div className={'col-md-6'}>
                      <div
                        className={clsx({
                          'form-group': true,
                          error: informationErrors.email
                        })}
                      >
                        <label className={'form-label'}>Email</label>
                        <input type='text' name='email' className='form-control' ref={informationRegister} />
                        <label className={'label-help'}>{informationErrors.email?.message}</label>
                      </div>
                    </div>
                    <div className={'col-md-6'}>
                      <div
                        className={clsx({
                          'form-group': true,
                          error: informationErrors.mobile_phone
                        })}
                      >
                        <label className={'form-label'}>Phone Number</label>
                        <input type='text' name='mobile_phone' className='form-control' ref={informationRegister} />
                        <label className={'label-help'}>{informationErrors.mobile_phone?.message}</label>
                      </div>
                    </div>
                    <div className={'col-md-6'}>
                      <div
                        className={clsx({
                          'form-group': true,
                          error: informationErrors.dob
                        })}
                      >
                        <label className={'form-label'}>Date of Birth</label>
                        <Controller
                          name={'dob'}
                          control={informationControl}
                          defaultValue={null}
                          render={({ value, onChange }) => (
                            <VuiDateRangePicker startDate={value} onChange={onChange} single={true} timePicker={false} />
                          )}
                        />
                        <label className={'label-help'}>{_.get(informationErrors.dob, 'message')}</label>
                      </div>
                    </div>
                    <div className={'col-md-6'}>
                      <div
                        className={clsx({
                          'form-group': true,
                          error: informationErrors.role_id
                        })}
                      >
                        <label className={'form-label'}>Role</label>
                        <div className={'form-select-wrapper'}>
                          <Controller
                            name={'role_id'}
                            control={informationControl}
                            defaultValue={null}
                            render={props => (
                              <VuiSelect selectRepository={RoleRepository} defaultValue={props.value} onChange={props.onChange} />
                            )}
                          />
                        </div>
                        <label className={'label-help'}>{_.get(informationErrors.role_id, 'message')}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={'card-paper'}>
                <div className={'card-header'}>
                  <h6 className={'card-header-title'}>{t('Payroll')}</h6>
                </div>
                <div className={'card-content'}>
                  <div className='row'>
                    <div className='col-md-6'>
                      <div
                        className={clsx({
                          'form-group': true,
                          error: _.get(informationErrors, 'user_payroll.monthly')
                        })}
                      >
                        <label className={'form-label'}>Monthly</label>
                        <div className={'form-select-wrapper type-with-button'}>
                          <Controller
                            name={'user_payroll.monthly'}
                            control={informationControl}
                            rules={{
                              required: true
                            }}
                            render={props => (
                              <NumberFormat
                                className='form-control'
                                value={props.value}
                                allowNegative={false}
                                thousandSeparator={'.'}
                                decimalSeparator={','}
                                decimalScale={0}
                                prefix={'IDR '}
                                placeholder={'IDR 0'}
                                onValueChange={({ value }) => props.onChange(value)}
                              />
                            )}
                          />
                        </div>
                        <label className={'label-help'}>{_.get(informationErrors, 'user_payroll.monthly.message')}</label>
                      </div>
                    </div>

                    <div className='col-md-6'>
                      <div
                        className={clsx({
                          'form-group': true,
                          error: _.get(informationErrors, 'user_payroll.daily')
                        })}
                      >
                        <label className={'form-label'}>Daily</label>
                        <div className={'form-select-wrapper type-with-button'}>
                          <Controller
                            name={'user_payroll.daily'}
                            control={informationControl}
                            rules={{
                              required: true
                            }}
                            render={props => (
                              <NumberFormat
                                className='form-control'
                                value={props.value}
                                allowNegative={false}
                                thousandSeparator={'.'}
                                decimalSeparator={','}
                                decimalScale={0}
                                prefix={'IDR '}
                                placeholder={'IDR 0'}
                                onValueChange={({ value }) => props.onChange(value)}
                              />
                            )}
                          />
                        </div>
                        <label className={'label-help'}>{_.get(informationErrors, 'user_payroll.daily.message')}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className={'profile-picture-section'}>
              <div className={'card-paper floating-content'}>
                <div className={'card-header'}>
                  <h6 className={'card-header-title'}>{t('Profile Picture')}</h6>
                </div>
                <div className={'card-content'}>
                  <div
                    className={clsx({
                      'form-group': true,
                      error: informationErrors.photo_id
                    })}
                  >
                    <Controller
                      name='photo_id'
                      control={informationControl}
                      defaultValue={null}
                      render={({ value, onChange }) => <VuiUploadImage className='type-center' defaultValue={value} onChange={onChange} />}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <VuiActionForm loading={informationLoading.get()} cancelLink={'/setting/user'} />
        </form>
      </div>
    </>
  );
};

export default SettingUserForm;
